import { render } from "./CustomerHeader.vue?vue&type=template&id=2ec23847&scoped=true&ts=true"
import script from "./CustomerHeader.vue?vue&type=script&lang=ts"
export * from "./CustomerHeader.vue?vue&type=script&lang=ts"

import "./CustomerHeader.vue?vue&type=style&index=0&id=2ec23847&scoped=true&lang=scss"

import exportComponent from "/opt/apps/parcel4you-web-staging/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ec23847"]])

export default __exports__